module.exports = new __parcel__URL__("poweredByGoogle.157f9230.png").toString();